import React, {
  useRef, useState, useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';

import { RideButton } from '@rimac-seguros/ride-system-components';

import { getTagActionName } from '../../../utils/analytics';

import { modeSearch, locations } from './constants/general';
import { clinics, suggestions } from './constants/clinics';
import { convertClinicTree, getClinicsToSearch } from './service';
import { InputSearch } from './InputSearch';
import ClinicCard from './ClinicCard';

const ModalClinics = ({
  onClose, btnText, btnAction,
}) => {
  const [location, setLocation] = useState('limaCallao');
  const [clinicFiltered, setClinicFiltered] = useState({});
  const clinicsData = useRef(getClinicsToSearch(clinics));

  const onFilterPlan = (clinic, mode) => {
    const { data, location } = convertClinicTree(clinic);
    const refButtons = document.getElementsByClassName('clinic-content_buttons');

    setClinicFiltered({
      mode,
      data,
      location,
    });
    setLocation(location);
    if (mode === modeSearch.change && refButtons && refButtons[0]) {
      refButtons[0].scrollIntoView({ top: 500, behavior: 'smooth' });
    }
  };

  const onFilterPlanMobile = (mode) => {
    if (mode === modeSearch.reset) {
      setClinicFiltered({
        mode,
        data: {},
        location,
      });
    }
  };

  const handleClickLocation = (item) => {
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Modal - Lista de clínicas', item.label, 'trackAction');
    setLocation(item.id);
  };

  const handleClose = () => {
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Modal - Lista de clínicas', 'Cerrar', 'trackAction');
    onClose();
  };

  useEffect(() => {
    const { cssText } = document.body.style;
    document.body.style.cssText = 'overflow-y: hidden;';
    return () => {
      document.body.style.cssText = cssText;
    };
  }, []);

  const getListClinics = useMemo(() => {
    const list = clinicFiltered?.mode === modeSearch.change ? clinicFiltered.data : clinics;
    const orderList = location === 'provinces' ? list[location].sort((a, b) => a.name.localeCompare(b.name)) : list[location];
    return orderList.map((_) => (
      <ClinicCard key={_.name} title={_.name} list={_.list} isToggle={location === 'provinces'} />
    ));
  }, [location, clinicFiltered]);

  return (
    <div className="modal-clinics">
      <div onClick={handleClose} className="modal-clinics-close only-mobile">
        <span>Cerrar</span>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="15.5" stroke="#7981B2" />
          <path d="M11 11L21 21" stroke="#7981B2" strokeLinecap="round" />
          <path d="M21 11L11 21" stroke="#7981B2" strokeLinecap="round" />
        </svg>
      </div>

      <div className="container">
        <div className="modal-clinics-container">
          <div onClick={handleClose} className="modal-clinics-close">
            <span>Cerrar</span>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="15.5" stroke="#7981B2" />
              <path d="M11 11L21 21" stroke="#7981B2" strokeLinecap="round" />
              <path d="M21 11L11 21" stroke="#7981B2" strokeLinecap="round" />
            </svg>
          </div>
          <div className="modal-clinics-body">
            <div className="modal-clinics-body__content">
              <div className="clinic-content">
                <InputSearch
                  onFilterPlan={onFilterPlan}
                  onFilterPlanMobile={onFilterPlanMobile}
                  placeholder="Busca tu clínica"
                  suggestions={suggestions}
                  clinicsData={clinicsData.current}
                />

                <h3>{clinics.title}</h3>
                <p>{clinics.subtitle}</p>
                <div className="clinic-content_buttons">
                  {locations.map((item, i) => (
                    <RideButton
                      key={i}
                      onClick={() => handleClickLocation(item)}
                      text={item.label}
                      variant={location === item.id ? 'fill' : 'outline'}
                      size="medium"
                    />
                  ))}
                </div>
              </div>

              <div className="clinic-content_clinics">
                {getListClinics}
              </div>

              <div className="clinic-content_disclaimer">
                <p>Los clínicas que se muestran son parciales y se encuentran vigentes desde el 01 de Junio del 2025 para venta nueva y renovaciones. Para mayor detalle llamar al 411-1111.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-clinics-footer">
        <div className="container">
          <div className="modal-clinics-container">
            <div className="modal-clinics-footer_wrapper">
              <span className="footer-text">¿Te interesa este plan?</span>
              <RideButton onClick={() => btnAction()} size="x-large" text={btnText} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ModalClinics.propTypes = {
  onClose: PropTypes.func.isRequired,
  btnText: PropTypes.string.isRequired,
  btnAction: PropTypes.func.isRequired,
};

export default ModalClinics;
